module.exports = __webpack_public_path__ + "static/img/zzbj_jcjg_icon.png";